export enum adminRecommendJobsTypes {
    FETCH_ADMIN_RECOMMEND_JOBS_REQUEST = "FETCH_ADMIN_RECOMMEND_JOBS_REQUEST",
    FETCH_ADMIN_RECOMMEND_JOBS_SUCCESS = "FETCH_ADMIN_RECOMMEND_JOBS_SUCCESS",
    FETCH_ADMIN_RECOMMEND_JOBS_FAILURE = "FETCH_ADMIN_RECOMMEND_JOBS_FAILURE",
  }